/**
 * Site Identity Configuration
 * ============================
 * Per-profile: change values for each branch/site.
 */

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://anushcuidarte.com.ar';

export const SITE = {
  name: 'Anush Cuidarte',
  shortName: 'Anush Cuidarte',
  tagline: 'Posteos sobre lactancia, crianza y cuidados',
  url: SITE_URL,
  description:
    'Posteos sobre lactancia materna, puericultura, crianza y acompañamiento consciente.',
  language: 'es',
  locale: 'es_AR',
};

export const AUTHOR = {
  name: 'Anush Camacho',
  bio: '',
  hobby: '',
  ctaText: '',
};

export const HEADER = {
  title: SITE.name,
  subtitle: 'Posteos sobre lactancia, crianza y cuidados',
};

export const SOCIAL_MEDIA = {
  instagram: 'https://www.instagram.com/anush.cuidarte/',
  facebook: '',
  tiktok: '',
  youtube: '',
};

export const SOCIAL_HANDLES = {
  instagram: 'anush.cuidarte',
  facebook: '',
  facebookId: '',
};

export const CONTACT = {
  email: 'info@anush.com.ar',
  phoneSupport: '',
};

export const ASSETS = {
  logo: `${SITE_URL}/logo.jpg`,
  defaultImage: `${SITE_URL}/og-default.jpg`,
};

export const SEO_DEFAULTS = {
  cuisine: '',
  siteName: SITE.name,
  defaultDescription: SITE.description,
  siteUrl: SITE_URL,
  defaultImage: `${SITE_URL}/og-default.jpg`,
};

export const SOCIAL_MEDIA_ARRAY = Object.values(SOCIAL_MEDIA).filter(Boolean);

export const CONTACT_POINT = {
  type: 'Customer Service',
  email: CONTACT.phoneSupport,
};

export const URLS = {
  home: SITE_URL,
  sitemap: `${SITE_URL}/sitemap.xml`,
  robots: `${SITE_URL}/robots.txt`,
  getDetailUrl: (slug) => `${SITE_URL}/${slug}/`,
  getImageUrl: (imagePath) => `${SITE_URL}/${imagePath}`,
};
